import {React,useEffect} from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { Country, State, City } from 'country-state-city';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';


const StateList = () => {
    const { id } = useParams();

    const getStatesByCountry = State.getStatesOfCountry(id);
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, []);

    return (
        <>
            <h1 className='text-center'>State List</h1>
            <MDBTable striped>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>#</th>
                        <th scope='col'>State Name</th>
                        <th scope='col'>ISO Code</th>
                        <th scope='col'>Lattitude</th>
                        <th scope='col'>Longitude</th>
                        <th scope='col'>Link</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {getStatesByCountry.map((item, index) => (
                        <tr>

                            <th scope='row'>{index + 1}</th>
                            <td>{item.name}</td>
                            <td>{item.isoCode}</td>
                            <td>{item.latitude}</td>
                            <td>{item.longitude}</td>
                            <td><Link to={`/CityList/${item.countryCode}/${item.isoCode}`}>Link</Link></td>
                        </tr>
                    ))}

                </MDBTableBody>
            </MDBTable>

        </>
    )
}

export default StateList